import { Line, mixins as chartMixins } from 'vue-chartjs'
import ChartPlugin from '@/components/charts/add-plugin'

import { mixins } from 'vue-class-component';
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
@Component
export default class LineChart extends mixins(Vue, Line) {
  @Prop({ type: Object })
  chartData: Object;
  @Prop({ type: Object })
  options: Object;
  plugin: ChartPlugin = new ChartPlugin();

  mounted() {
    this.renderChart(this.chartData, this.options || this.plugin.DEFAULT_OPTION);
  }
  @Watch('chartData')
  @Watch('options')
  updateChart() {
    this.renderChart(this.chartData, this.options || this.plugin.DEFAULT_OPTION);
  }
}